import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";

import { MailList } from "api/memberPortal/mailList/mailList.types";
import { niapColorFamily } from "utils/color";
import { pluralize } from "utils/stringFormatting";

import MailListCardCompact from "../MailListCard/MailListCardCompact";

interface MailListAccordionProps {
  data: MailList[];
}

export default function MailListAccordion({ data }: MailListAccordionProps) {
  if (!data) return <></>;

  const cardByCategory = Object.groupBy(data, (card) => {
    if (card.category) return card.category?.name;
    else return "General";
  });
  if (!cardByCategory) return <></>;

  return (
    <Stack spacing={3}>
      {Object.keys(cardByCategory)
        .sort((a, b) => a.localeCompare(b))
        .map((category) => {
          const mailLists = cardByCategory[category];
          if (!mailLists) return null;

          const categoryColor =
            mailLists[0]?.category?.themeColor ?? "ink.light";

          return (
            <Accordion
              key={category}
              sx={{
                boxShadow: 0,
                border: "none",
                "&::before": { display: "none" },
              }}
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  borderLeft: 10,
                  borderColor: categoryColor,
                  "&:hover": {
                    backgroundColor: "glyph.light",
                  },
                }}
              >
                <Stack direction="row" alignItems="center" gap={2}>
                  <Typography variant="h2">{category}</Typography>
                  <Chip
                    label={pluralize(mailLists.length, "List")}
                    color={niapColorFamily(categoryColor)}
                    sx={{
                      fontSize: 16,
                    }}
                  />
                </Stack>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 4 }}>
                <Grid container spacing={2}>
                  {mailLists.map((mailList) => (
                    <Grid key={mailList.id} size={{ xs: 12, md: 6, lg: 4 }}>
                      <MailListCardCompact
                        title={mailList.name}
                        email={mailList.email}
                        memberCount={mailList.memberCount}
                        description={mailList.description}
                        id={mailList.id}
                        categoryColor={
                          mailList.category?.themeColor ?? "ink.light"
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
    </Stack>
  );
}
